import React from 'react';

/**
 * CurrentCycleCard — Card 2 in the vertical hierarchy.
 * Renders serif day number, right-aligned meta, confidence dots,
 * and an in-card primary CTA. Respects the never-auto-reset logic:
 * when `waiting=true`, shows the amber waiting-strip and promotes
 * the CTA to filled brand.
 */
export default function CurrentCycleCard({
  day,
  meta,
  confidence,
  confidenceOn,
  waiting,
  waitingText,
  cta,          // { label, variant: 'ghost' | 'warning' }
  onHistory,
  onLog,
}) {
  return (
    <div className="cx-glass" data-testid="card-current-cycle">
      <div className="cx-card-hd">
        <div className="cx-card-lbl">Current Cycle</div>
        <button className="cx-card-view" onClick={onHistory} data-testid="card-current-cycle-history">
          History
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="m9 6 6 6-6 6"/>
          </svg>
        </button>
      </div>

      {waiting && (
        <div className="cx-waiting-strip" data-testid="waiting-strip">
          <span className="cx-p">Waiting</span>
          <span className="cx-t">{waitingText}</span>
        </div>
      )}

      <div className="cx-cycle-main">
        <div>
          <div className="cx-cycle-big">
            <span className="cx-lbl">Day</span>
            <span>{day}</span>
          </div>
        </div>
        <div className="cx-cycle-meta">
          {meta.map((line, i) => (
            <div key={i}
                 className={
                   line.kind === 'strong' ? 'cx-m1'
                   : line.kind === 'late' ? 'cx-m1 cx-late'
                   : 'cx-m2'}>
              {line.kind === 'strong'
                ? <>{line.primary.replace(/(\d+\s+day[s]?|day\s+\d+\s+of\s+\d+)/, '')}<b>{(line.primary.match(/(\d+\s+day[s]?|day\s+\d+\s+of\s+\d+)/) || [''])[0]}</b></>
                : line.primary}
            </div>
          ))}
        </div>
      </div>

      <div className="cx-conf-row">
        <div className="cx-conf-l">Confidence <span>{confidence}</span></div>
        <div className="cx-conf-dots">
          {[0, 1, 2].map(i => (
            <div key={i} className={'cx-d' + (i < confidenceOn ? ' cx-on' : '')}/>
          ))}
        </div>
      </div>

      <button
        className={'cx-cta' + (cta.variant === 'warning' ? ' cx-warning' : '')}
        onClick={onLog}
        data-testid="log-period-btn"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
          <path d="M12 5v14M5 12h14"/>
        </svg>
        {cta.label}
      </button>
    </div>
  );
}
